import { useCallback, useEffect, useState } from "react";
import Cropper from "react-easy-crop";
import { dayPack, hipPack, travelPack } from "../../addPackingList/utils";
import { BASE_URL_IMAGE } from "../../../../../services/ApiEndpoints";
import ToggleSwitch from "../../../../../components/toggleSwitch";
import { convertBlobToBase64, getCroppedImg } from "../../../../../utils/helpers";

const BottomWidgets = ({ widgetData, setWidgetData }) => {
    const [errors, setErrors] = useState({});
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);
    const [bottomWidget, setBottomWidget] = useState({
        keyName: null,
        currentFile: null,
        isModalOpen: false,
    })
    const updateState = (key, value) => {
        setBottomWidget((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };
    const handleInputChange = (key, field, value) => {
        setWidgetData((prev) => ({
            ...prev,
            [key]: {
                ...prev[key],
                [field]: value,
            },
        }));
    };

    const togglePro = (key) => {
        setWidgetData((prev) => ({
            ...prev,
            [key]: {
                ...prev[key],
                type: prev[key].type === "pro" ? "regular" : "pro",
            },
        }));
    };



    const onFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            updateState("currentFile", file)
            updateState("isModalOpen", true)
            reader.readAsDataURL(file);
            // reader.onload = () => {
            //     // setImageSrc(reader.result);
            //     setIsModalOpen(true);
            // };
        }
    };

    const triggerFileInput = (key) => {
        updateState("keyName", key)
    };

    const handleCrop = async () => {
        try {
            if (!croppedAreaPixels) {
                throw new Error("Crop area is not set properly.");
            }
            const imageSrc = URL.createObjectURL(bottomWidget?.currentFile)


            const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);

            // Clean up memory
            URL.revokeObjectURL(imageSrc);

            if (!croppedImage) {
                throw new Error("Failed to process cropped image.");
            }

            const croppedImageBase64 = await convertBlobToBase64(croppedImage)


            if (!croppedImageBase64) {
                console.error("Failed to generate cropped image!");
                return;
            }
            // Convert Base64 to Blob
            // const blob = dataURLtoBlob(croppedImage);
            // if (!blob) {
            //     throw new Error("Failed to convert cropped image to Blob.");
            // }

            // Convert Blob to File
            // const file = new File([croppedImage], "cropped-image.png", { type: "image/png" });

            // // Ensure file size is reasonable
            // if (file.size > 5 * 1024 * 1024) { // 5MB limit
            //     throw new Error("Cropped image is too large. Please crop a smaller area.");
            // }
            handleInputChange(bottomWidget.keyName, `${bottomWidget.keyName}Image`, croppedImageBase64);
            updateState("currentFile", null);
            updateState("isModalOpen", false);

        } catch (error) {
            console.error("Error during cropping:", error.message);
            alert(error.message); // Show error message to user
        }
    };
    return (
        <div className="p-4  bg-[#F9F9F9]">
            <div className="bg-white p-4">
                {Object.keys(widgetData).filter(key => key !== "tags" && key !== "tripLength" && key !== "activities" && key !== "widgets").map((key, index) => (
                    <div
                        key={key}
                    >
                        <h2 className="text-left font-bold font-roboto-mono text-lg">
                            {key.charAt(0).toUpperCase() + key.slice(1)}
                        </h2>

                        <div className="grid md:grid-cols-7 grid-cols-1 gap-4 mb-5">
                            <div className="col-span-1 self-center">
                                <label className=" ">
                                    Default type
                                </label>
                                <ToggleSwitch checked={widgetData[key]?.type === "pro"} onChange={() => togglePro(key)} />

                            </div>

                            {widgetData[key]?.type === "pro" ? (
                                <>
                                    <div className="col-span-2 self-center" >

                                        <label htmlFor=""> Default URL </label>
                                        <input
                                            type="text"
                                            placeholder="Enter URL"
                                            value={widgetData[key].url}
                                            onChange={(e) => handleInputChange(key, "url", e.target.value)}
                                            className="border border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-full"
                                        />
                                    </div>
                                    <div className="col-span-2 flex flex-col self-center">
                                        <label htmlFor="">Default Image</label>
                                        <input
                                            type="file"
                                            id="current-img"
                                            className="hidden"
                                            accept="image/*"
                                            onChange={onFileChange}
                                        />
                                        <label
                                            htmlFor="current-img"
                                            onClick={() => triggerFileInput(key)}
                                            className="border border-bgprimary text-[#1F2937AB] font-medium text-[16px] font-quicksand rounded-md p-2 w-full"
                                        >
                                            Upload Image
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        {widgetData[key]?.[`${key}Image`] && (
                                            <img
                                                src={widgetData[key][`${key}Image`].startsWith("data:image")
                                                    ? `${widgetData[key][`${key}Image`]}`
                                                    : `${BASE_URL_IMAGE}${widgetData[key][`${key}Image`]}` // Handle file object
                                                }
                                                alt={key}
                                                className="w-40 h-40 object-cover border rounded-md"
                                            />
                                        )}
                                    </div>


                                    <div className="col-span-5">
                                        <input
                                            type="text"
                                            placeholder="Enter Description"
                                            value={widgetData[key].description}
                                            onChange={(e) => {
                                                const value = e.target.value.substring(0, 185); // Restrict to 185 characters
                                                handleInputChange(key, "description", value);
                                            }}
                                            className="border border-bgprimary text-[#1F2937AB] font-medium h-28  text-[16px] font-quicksand rounded-md p-2 w-full"
                                        />
                                        <div className="flex justify-end text-right" >{widgetData[key]?.description?.length || 0}/185</div>
                                    </div>

                                </>

                            ) : (
                                <>
                                    <select
                                        value={widgetData[key]?.size}
                                        onChange={(e) => handleInputChange(key, "size", e.target.value)}
                                        className="border border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-full"
                                    >
                                        <option >Select Size</option>
                                        {(index == 1 ? travelPack : index == 2 ? dayPack : hipPack).map((item, index) => {
                                            return (
                                                <option key={index} value={item}>{item}</option>
                                            )
                                        })}
                                        <option value="None">None</option>

                                    </select>

                                </>

                            )}
                        </div>
                    </div>
                ))}
            </div>


            {bottomWidget?.isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-4 rounded-lg shadow-lg w-[350px] h-[600px] relative">
                        <h2 className="text-lg font-bold mb-2">Crop Your Image</h2>
                        <div className="crop-container h-[200px] w-full">
                            <Cropper
                                image={URL.createObjectURL(bottomWidget.currentFile)}
                                crop={crop}
                                zoom={zoom}
                                aspect={4 / 3}
                                onCropChange={setCrop}
                                onCropComplete={onCropComplete}
                                onZoomChange={setZoom}
                                style={{ height: "200px", width: "100%" }}
                            />
                        </div>
                        <div className="controls">
                            <input
                                type="range"
                                value={zoom}
                                min={1}
                                max={3}
                                step={0.1}
                                aria-labelledby="Zoom"
                                onChange={(e) => {
                                    setZoom(e.target.value)
                                }}
                                className="zoom-range"
                            />
                        </div>

                        <div className="flex justify-end space-x-2 mt-4 absolute bottom-4 left-[35%] translate-x-[-50%] w-full">
                            <button className="px-4 py-2 bg-gray-400 text-dark rounded border border-bgprimary" onClick={() => updateState("isModalOpen", false)}>
                                Cancel
                            </button>
                            <button className="px-4 py-2 bg-bgprimary text-dark font-roboto-mono font-bold rounded" onClick={handleCrop}>
                                Crop & Save
                            </button>
                        </div>



                    </div>
                </div>
            )}

        </div>
    )
}

export default BottomWidgets
